/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Feature_5_SubmissionsInputs */

const en_landing_pricing_feature_5_submissions = /** @type {(inputs: Landing_Pricing_Feature_5_SubmissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 tool submissions`)
};

const zh_landing_pricing_feature_5_submissions = /** @type {(inputs: Landing_Pricing_Feature_5_SubmissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`5 次工具提交`)
};

/**
* | output |
* | --- |
* | "5 tool submissions" |
*
* @param {Landing_Pricing_Feature_5_SubmissionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_feature_5_submissions = /** @type {((inputs?: Landing_Pricing_Feature_5_SubmissionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Feature_5_SubmissionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_feature_5_submissions(inputs)
	return zh_landing_pricing_feature_5_submissions(inputs)
});
export { landing_pricing_feature_5_submissions as "landing.pricing.feature_5_submissions" }